module.exports = __webpack_public_path__ + "img/icon_gps.c698cae1.svg";